var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 199 199" } },
    [
      _c("title", [_vm._v("battery-17-17")]),
      _c("g", { attrs: { id: "Battery" } }, [
        _c("path", {
          staticClass: "cls-1",
          attrs: {
            d: "M178.26,149.52l-155,0,0-92,155,0ZM73.51,43.49h-31v14h31Zm85,0h-31v14h31Zm27.48,106-170.5,0v6l170.5,0Zm-31.49-64h-24m-61,0h-24m97,12v-24m-98-23h29m55.5,0h29",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }